import xlsx from 'xlsx'
import { BotFlow } from '@feedyou-ai/feedbot-schema'

import { Roles } from '../../../constants/roles'

export type XlsPackage = typeof xlsx

export type ErrorMessages = { steps?: string; nlp?: string }

export type ImportResult = { flow?: BotFlow; errorMessages?: ErrorMessages }

export enum NlpSheetPrefixes {
  INTENTS = '-intents',
  EXAMPLES = '-examples',
  TRIGGERS = '-triggers',
  VARIABLES = '-variables'
}

export type ViewToken = {
  token: string
  role: Roles
  name?: string | undefined
  analytics?: boolean | undefined
}

export type PromptForExport = {
  exportConfirmed: boolean
  excludeUnused: boolean
  excludeInaccessible: boolean
  excludeDisabled: boolean
}
